var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54894 1.38945C6.8483 0.46814 8.1517 0.468143 8.45106 1.38945L9.40837 4.33576C9.54224 4.74778 9.9262 5.02674 10.3594 5.02674H13.4574C14.4261 5.02674 14.8289 6.26636 14.0451 6.83576L11.5389 8.65667C11.1884 8.91132 11.0417 9.36269 11.1756 9.77471L12.1329 12.721C12.4323 13.6423 11.3778 14.4084 10.5941 13.839L8.08778 12.0181C7.7373 11.7635 7.2627 11.7635 6.91221 12.0181L4.40594 13.839C3.62222 14.4085 2.56774 13.6423 2.8671 12.721L3.82441 9.77471C3.95828 9.36268 3.81162 8.91132 3.46114 8.65667L0.954859 6.83576C0.171145 6.26636 0.573923 5.02674 1.54265 5.02674H4.64057C5.0738 5.02674 5.45776 4.74778 5.59163 4.33576L6.54894 1.38945Z",
    fill: "#FFE14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/subscribe.c0a651b9b0f289a7bd015ec2ac9ac5c6.svg";
export { ForwardRef as ReactComponent };